/**
 * IAMONEAI Typing Indicator
 * Shows "AI is typing..." animation during streaming
 * 
 * @version 3.0
 */

import React from 'react';
import './TypingIndicator.css';

/**
 * Typing indicator with animated dots
 * 
 * @param {Object} props
 * @param {string} props.name - AI name to display (default: "IAMONEAI")
 * @param {string} props.context - Current context mode for styling
 */
export function TypingIndicator({ name = 'IAMONEAI', context = 'personal' }) {
  return (
    <div className={`typing-indicator typing-indicator--${context}`}>
      <div className="typing-indicator__avatar">
        <span className="typing-indicator__icon">🧠</span>
      </div>
      <div className="typing-indicator__content">
        <span className="typing-indicator__name">{name}</span>
        <div className="typing-indicator__dots">
          <span className="typing-indicator__dot"></span>
          <span className="typing-indicator__dot"></span>
          <span className="typing-indicator__dot"></span>
        </div>
      </div>
    </div>
  );
}

/**
 * Inline typing indicator (just dots)
 */
export function TypingDots() {
  return (
    <span className="typing-dots-inline">
      <span className="typing-dot-inline"></span>
      <span className="typing-dot-inline"></span>
      <span className="typing-dot-inline"></span>
    </span>
  );
}

export default TypingIndicator;
